import { useState, useEffect, useCallback } from "react";
import { fetchDraftProjects } from "../../services/draftProjects.service";

const useDraftProjects = (search, boolSearch, tabKey) => {
  const [projects, setProjects] = useState([]);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    currentPage: 1,
    totalPages: 0,
    pageSize: 10,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadProjects = useCallback(
    async (page = 1) => {
      if (tabKey === "draftprojects") {
        setIsLoading(true);
        setError(null);

        try {
          const data = await fetchDraftProjects(
            page,
            pagination.pageSize,
            search // 👈 Pass search here, not key
          );
          setProjects(data.data.projects);
          setPagination({
            totalCount: data.data.totalCount,
            currentPage: page,
            totalPages: data.data.pages,
            pageSize: pagination.pageSize,
          });
        } catch (error) {
          console.error("Failed to fetch draft projects:", error);
          setError(
            error.response?.data?.message || "Failed to fetch draft projects"
          );
        } finally {
          setIsLoading(false);
        }
      }
    },
    [pagination.pageSize, search, boolSearch, tabKey] // 👈 Add search here
  );

  const handlePageChange = useCallback(
    (page) => {
      loadProjects(page);
    },
    [loadProjects]
  );

  useEffect(() => {
    loadProjects(1);
  }, [boolSearch, tabKey]); // 👈 Remove search from here if you only want to search on button click

  return {
    projects,
    pagination,
    isLoading,
    error,
    handlePageChange,
    loadProjects,
  };
};

export default useDraftProjects;
